export default __webpack_public_path__ + "static/mapaFront-478567c27ae148321d0b3cf2370a47b0.png";